// import { banner77 } from './NewBanner'
import { BannerItem } from './NewBanner.types'
import { handleCarouselClick } from './NewBannerHelpers'
import style from './NewBunner.module.scss'

export default function CollectionPromoBanner({
  place,
  id,
  pageType,
  bannerData,
  customClass,
}: {
  place: string | undefined
  id: string | undefined
  pageType: string
  bannerData: BannerItem
  customClass?: string
}) {
  return (
    <a
      href={bannerData.href}
      target='_blank'
      onClick={() => {
        handleCarouselClick(
          `${bannerData.name} ${bannerData.text}`,
          id,
          pageType,
          place
        )
      }}
      className={[style.NewBanner].join(' ')}
    >
      <div
        className={`${style.banner} ${customClass ? style[customClass] : ''}`}
      >
        <div
          className={style.banner__price}
          style={{ background: bannerData.color }}
        >
          <p
            className={style['banner__price-value']}
            dangerouslySetInnerHTML={{ __html: bannerData.name }}
          ></p>
        </div>
        <div className={style.banner__info}>
          <p
            className={style['banner__info-text']}
            dangerouslySetInnerHTML={{ __html: bannerData.text }}
          ></p>
          {bannerData.lead && (
            <p
              className={style['banner__info-lead']}
              dangerouslySetInnerHTML={{ __html: bannerData.lead }}
            ></p>
          )}
        </div>
      </div>
    </a>
  )
}
